import request from '@/utils/request'


// 查询特价活动商品列表
export function listSpecialActivityProd(query) {
  return request({
    url: '/specialActivityProd/specialActivityProd/list',
    method: 'get',
    params: query
  })
}

// 查询特价活动商品分页
export function pageSpecialActivityProd(query) {
  return request({
    url: '/specialActivityProd/specialActivityProd/page',
    method: 'get',
    params: query
  })
}

// 查询特价活动商品详细
export function getSpecialActivityProd(data) {
  return request({
    url: '/specialActivityProd/specialActivityProd/detail',
    method: 'get',
    params: data
  })
}

// 新增特价活动商品
export function addSpecialActivityProd(data) {
  return request({
    url: '/specialActivityProd/specialActivityProd/add',
    method: 'post',
    data: data
  })
}

// 修改特价活动商品
export function updateSpecialActivityProd(data) {
  return request({
    url: '/specialActivityProd/specialActivityProd/edit',
    method: 'post',
    data: data
  })
}

// 删除特价活动商品
export function delSpecialActivityProd(data) {
  return request({
    url: '/specialActivityProd/specialActivityProd/delete',
    method: 'post',
    data: data
  })
}

// 审核特价活动商品
export function auditSpecialActivityProd(data) {
  return request({
    url: '/specialActivityProd/specialActivityProd/audit',
    method: 'post',
    data: data
  })
}
